import gql from 'graphql-tag';

import client from '../graphqlAPI';

const MASS_POST_POST_MUTATION = gql`
  mutation Post($posts: [String]!, $publish: Boolean) {
    massPostModif(posts: $posts, publish: $publish) {
      isAuth
      isEdited
      error
    }
  }
`;

const massPostModif = async ({
  posts, publish,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: MASS_POST_POST_MUTATION,
        variables: {
          posts, publish,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { massPostModif: massPostModifValidationData },
    } = result;

    if (massPostModifValidationData) {
      return massPostModifValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: massPostModifValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: massPostModif Error: ${error}`);
    return null;
  }
};

export default massPostModif;
